import * as types from '../const/action.types';

export function user(state = {}, action) {
    switch (action.type) {
        case types.LOAD_USER_SUCCESS:
            console.log(action.data);
            return action.data;
        case types.LOG_OUT:
            return {};
        default:
            return state;
    }
}

export function users(state = [], action) {
    switch (action.type) {
        case types.USERS_SUCCESS:
            return action.data;
        default:
            return state;
    }
}

export function usersHasErrored(state = { hasErrored: false, error: '' }, action) {
    switch (action.type) {
        case types.USER_HAS_ERROR:
            return {
                hasErrored: action.hasErrored,
                error: action.error,
            };

        default:
            return state;
    }
}

export function usersIsLoading(state = false, action) {
    switch (action.type) {
        case types.USERS_IS_LOADING:
            return action.isLoading;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/user.reducer.js